// Internal
import { fetchCatalogTypes, fetchCatalogTypeById, deleteCatalogType } from './actions';

// Constants
export const DEFAULT_CATALOG_TYPES_STATE = {
  data: {}
};

const normalize = (state, catalogTypes) => ({
  ...state,
  catalogTypes
});

const catalogTypesReducer = (state, action) => {
  const { catalogTypes } = state;

  switch (action.type) {
    case fetchCatalogTypes.event.success: {
      const { objects } = action.payload;
      const newData = {};
      objects.forEach(catalogType => {
        newData[catalogType.id] = catalogType;
      });

      return normalize(state, { ...catalogTypes, data: newData });
    }

    case fetchCatalogTypeById.event.success: {
      const catalogType = action.payload;
      const newData = {
        ...catalogTypes.data,
        [catalogType.id]: catalogType
      };

      return normalize(state, { ...catalogTypes, data: newData });
    }

    case deleteCatalogType.event.success: {
      const catalogTypeId = action.payload;
      const { [catalogTypeId]: id, ...newData } = catalogTypes.data;

      return normalize(state, { ...catalogTypes, data: newData });
    }

    default:
      return state;
  }
};

export default catalogTypesReducer;
